module.exports = __webpack_public_path__ + "static/media/RectangularSectionGeometry.57831a24.svg";